<template>
  <div :class="componentClasses">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  size: {
    type: String,
    default: '',
  },
  resize: {
    type: String,
    default: '',
  },
});

const componentClasses = computed(() => [
  'stk-html',
  props.size && !props.resize ? `stk-size-${props.size}` : '',
  props.resize ? `stk-resize-${props.resize}` : '',
]);
</script>


<style>
.stk-html {
  display: flex;
  flex-direction: column;
  gap: 0.5em;

  ol,
  ul {
    margin-left: 1.5em;
  }

  ol {
    list-style-type: decimal;
  }

  ul {
    list-style-type: disc;
  }
}
</style>
